import React from 'react';

import { createComponent } from '@lit/react';
import type { MdCircularProgress } from '@material/web/progress/circular-progress';

const MdCircularProgress2 = customElements.get("md-circular-progress");


const Circle = createComponent({

    tagName: 'md-circular-progress',

    // @ts-expect-error: Invalid cast
    elementClass: MdCircularProgress2 as unknown as MdCircularProgress,

    react: React,

    events: {
    },

});

export const M3InfiniteLoading = () => {
    // @ts-expect-error: Invalid cast
    return <Circle indeterminate={true} />
}